export const paths = [
  '/projects/:projectId/sheets',
  '/projects/:projectId/sheets/label/:versionSetId',
  '/projects/:projectId/sheets/:action/:sheetId',
];
